import { useTranslation } from 'react-i18next';

import TrialEndedIllustration from '../../../../assets/person-clock.svg';

export const ExpiredIllustration = (): JSX.Element => {
  const { t } = useTranslation('trials', { keyPrefix: 'post-trial' });

  return <img src={TrialEndedIllustration} alt={t('illustration')} />;
};
